<template>
  <div>
    <div class="container-fluid">
      <div class="row row-eq-height">
        <div class="v-center col-sm-6 grey-grad-bg">
          <div class="row v-bottom">
            <div class="col-md-6 col-md-offset-3 text-center">
              <div class="logo-image-container max-height">
                <img :src="logoUrl" class="logo-image" alt="logo">
              </div>
              <h1 class="text-uppercase">Welcome Back {{user.firstName}}!</h1>
              <p>Let the earnings begin! Earn Points for each valid submission or by watching a video. Redeem Points for Rewards!</p>
              <br><br>
              <router-link
                :to="{path: 'earn-points', params: {slug: ''}}"
                type="button"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
              >
                Earn Points
              </router-link>
              <br>
            </div>
          </div>
        </div>

        <div class="v-center col-sm-6 redeem-sec">
          <div class="row v-bottom">
            <div class="col-md-8 col-md-offset-2 text-center text-uppercase">
              <h1>Points Earned</h1>
              <span class="grey-type lrg-numbers"><strong>{{user.userLoyaltyProgram.totalPoints}}</strong></span>
              <br><br>
              <h1>Points left to redeem</h1>
              <span class="grey-type lrg-numbers"><strong>{{user.userLoyaltyProgram.currentPoints}}</strong></span>
              <router-link
                :to="{name: 'RedeemPoints'}"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                type="button"
              >
                Redeem Points
              </router-link>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ClientDashboard',
  mounted () {
    this.$store.dispatch('setSlug')
    this.getLoyaltyProgramBySlug(this.$store.state.slug)
      .then(result => {
        if (!result.data.program) {
          this.$router.push({ name: 'ClientProgramNotFound' })
        }
        return this.getUser()
      })
      .catch(err => {
        console.log(err)
      })
  },
  computed: {
    ...mapState('loyaltyProgram', {
      logoUrl: state => state.program.company ? state.program.company.logo.url : ''
    }),
    ...mapState('user', ['user'])
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug'
    ]),
    ...mapActions('user', ['getUser'])
  }
}
</script>

<style scoped>
.logo-image {
  max-width: 100%;
}

.v-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.v-bottom {
  display: flex;
  height: 60%;
  align-items: flex-end;
}
</style>
